export const formatBezierCurveCSS = bezierCurve => {
	return `cubic-bezier(${bezierCurve.join(',')})`
}

export const getParameterByName = (name, url) => {
	const parameterName = name.replace(/[[\]]/g, "\\$&");
	const regex = new RegExp(`[?&]${parameterName}(=([^&#]*)|&|#|$)`);
	const results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return "";
	return decodeURIComponent(results[2].replace(/\+/g, " "));
};
  
export const shallowOptionsDiff = (options, defaultOptions) => {
	let resultDiff = {};

	Object.keys(options).forEach(key => {
		if(key === 'lastUpdate') return;
		if(options[key] !== defaultOptions[key] ) {
			resultDiff[key] = options[key];
		}
	});

	return resultDiff;
}

export const constrain = (value, min, max) => {
	return Math.max(Math.min(value, max), min);
}

export const hasLocalStorage = () => {
    const mod = 'localstoragecheck';
    try {
      localStorage.setItem(mod, mod);
      localStorage.removeItem(mod);
      return true;
    } catch (e) {
      return false;
    }
}

export const formatDate = (date) => {
    let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
}

export const removeBlankLines = (text) => {
	return text.replace(/^\s*[\r\n]/gm, '');
}

export const removeWhiteSpace = (text) => {
	return text.replace(/^ +/gm, '');
}

export const indentCodeBlock = (text) => {
	return text.split('\n').map((line, index, arr) => {
		if(index > 0 && index < arr.length - 2) {
			return `  ${line}`;
		}else {
			return line;
		}
	}).join('\n');
}

export const isMobile = () => {
	const windowGlobal = typeof window !== 'undefined' && window
	return windowGlobal.innerWidth <= 768;
}

export const scrollToTop = () => {
	if(!document) {
		return;
	}
	
	document.body.scrollTop = document.documentElement.scrollTop = 0;
}